import type { TabProps } from '@mui/material';
import type { NavLinkProps } from 'react-router-dom';
import { NavLink, useLocation } from 'react-router-dom';
import type { CustomerPageTabOption } from '../customer-view-page-consts/customer-page-tabs';
import { CUSTOMER_PAGE_TAB_OPTIONS } from '../customer-view-page-consts/customer-page-tabs';

export function useCustomerPageTabs() {
  const location = useLocation();

  const tabs = Object.values({
    [CUSTOMER_PAGE_TAB_OPTIONS.RealtimeActivity]: {
      label: 'This Cycle',
      value: CUSTOMER_PAGE_TAB_OPTIONS.RealtimeActivity,
      component: NavLink,
      to: `${location.pathname}/../realtime-activity`,
      replace: true,
    },
    [CUSTOMER_PAGE_TAB_OPTIONS.Invoices]: {
      label: 'Invoices',
      value: CUSTOMER_PAGE_TAB_OPTIONS.Invoices,
      component: NavLink,
      to: `${location.pathname}/../invoices`,
      replace: true,
    },
    [CUSTOMER_PAGE_TAB_OPTIONS.Contract]: {
      label: 'Contract',
      value: CUSTOMER_PAGE_TAB_OPTIONS.Contract,
      component: NavLink,
      to: `${location.pathname}/../contract`,
      replace: true,
    },
    [CUSTOMER_PAGE_TAB_OPTIONS.Settings]: {
      label: 'Settings',
      value: CUSTOMER_PAGE_TAB_OPTIONS.Settings,
      component: NavLink,
      to: `${location.pathname}/../settings`,
      replace: true,
    },
  } satisfies Record<CustomerPageTabOption, TabProps<typeof NavLink, NavLinkProps>>);

  const currentTab = location.pathname.split('/').pop() as CustomerPageTabOption;

  return [tabs, currentTab] as const;
}